import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  Collapse,
  Form,
  Modal,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroller";
import { FaSearch } from "react-icons/fa";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "./serviceRequests.scss";
import avatar1 from "../../images/avatar/1.jpg";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getTickets } from "../../service/api/ticket/getTickets";
import { deleteCallHistory } from "../../service/api/callHistory/deleteSingleDetails";
import { ticketCallRequest } from "../../service/api/ticket/ticketCallRequest";

import { bulkCallDelete } from "../../service/api/callHistory/bulkCallDelete";
import DummyBackdropLoader from "../../component/backDrop/dummyBackDropLoader";
import ErrorBackdropLoader from "../../component/backDrop/errorBackDropLoader";
import BackDropLoaderWithoutUpdate from "../../component/backDrop/backDropLoaderWithoutUpdate";
import BackDrop from "../../component/backDrop/backDropLoader";
import UpdateServiceRequest from "../../component/updateServiceRequest/updateServiceRequest";
import ResponceForAPI from "../../component/backDrop/responcesForAPI";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import TextArea from "../../jsx/components/fields/textArea";
import { BsStarFill } from "react-icons/bs";
import { BiStar } from "react-icons/bi";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import {
  lblEnterProblemDescription,
  txtCategory,
  txtCreatedBy,
  txtDateTime,
  txtServiceID,
  txtServiceRequests,
  txtStatus,
} from "../../dataBaseFile/label";
import {
  btnAvailableServices,
  btnMyServices,
  btnOpenJobs,
} from "../../dataBaseFile/alert";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { validEmail_OR_MobileNumberText } from "../../dataBaseFile/error";
import {
  emailValidation,
  noSpaceOnChange,
  phoneValidation,
} from "../../functions/validations";
import shareServiceRequest from "../../service/api/ticket/shareServiceRequest";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import {
  setMyCurrentTab,
  setMyCurrentTabRedux,
} from "../../feature/serviceRequest/serviceRequestRedux";
import { getCounterApi } from "../../service/api/ticket/serviceCounters";
import { setCurrentPage } from "../../feature/userData/userData";
import CustomTable from "../../jsx/components/customTable/customTable";
import openServiceImg from '../../media/images/servicesAssets/openServiceImg.png'
import calendarImg from '../../media/images/servicesAssets/calendarImg.png'
import searchImg from '../../media/images/servicesAssets/searchImg.png'
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import SkeletonForServices from '../../component/skeletonTableRow/skeletonForServices';

const ServiceRequests = () => {
  const { role, permissionArr } = useSelector((state) => state.user);
  const { myCurrentTab } = useSelector((state) => state.service);

  const permissionArray = permissionArr[0] || [];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [sortByValue, setSortByValue] = useState("DESC");
  const [searchValue, setSearchValue] = useState("");
  const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
  const [skeltonVal, setSkeltonVal] = useState(false);
  const [columnName, setColumnName] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [elements, setElements] = useState([]);
  const [inProgressElements, setInProgressElements] = useState([]);
  const [completedElements, setCompletedElemets] = useState([]);
  const [cancelledElements, setCancelledElements] = useState([]);
  const [pendingElements, setPendingElements] = useState([]);
  const [assignServiceElements, setAssignServiceElements] = useState([]);
  const [paymentIssueElements, setPaymentIssueElements] = useState([]);
  const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);

  const [renderTicketListPro, setRenderTicketListPro] = useState(1);
  const [flag, setFlag] = useState(false);

  const [ticketID, setTicketID] = useState(null);
  const [counters, setCounters] = useState({});

  const [basicModal, setBasicModal] = useState(false);
  const [initiColor, setInitiColor] = useState(true);
  const [sortingCol, setSortingCol] = useState(true);
  const [callLogIdIds, setCallLogIdIds] = useState(null);
  const [userCallLogIdIds, setUserCallLogIdIds] = useState(null);
  const [showCallDetails, setShowCallDetails] = useState(false);
  const [sentRequest, setSentRequest] = useState([]);
  const [flagForTicket, setFlagForTicket] = useState(true);
  const [showShareServiceModal, setShowShareServiceModal] = useState(false);
  const handleShowShareServiceModal = () => setShowShareServiceModal(true);
  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState();
  const [isPhone, setIsPhone] = useState(false);
  const [shareLoading, setShareLoading] = useState(false);

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState("");
  const [handleToaster, setHandleToaster] = useState(false);

  const [isActiveSheduledCall, setIsActiveScheduledCall] = useState(0);

  const [filtreBox, setFiltreBox] = useState(false);
  const [filtreValue, SetFiltreValue] = useState(1);
  useEffect(() => {
    if (permissionArray?.includes("CONNECT TO PRO")) {
      dispatch(setCurrentPage("Pro Calls"));
    } else {
      dispatch(setCurrentPage("My Jobs"));
    }
  }, []);

  useEffect(() => {
    const ele = [];
    setPage(1);
    setElements(ele);
    setCancelledElements(ele);
    setInProgressElements(ele);
    setCompletedElemets(ele);
    setPendingElements(ele);
    setAssignServiceElements(ele);
    setPaymentIssueElements(ele);
    // onLoadData();
  }, [myCurrentTab]);

  const handleChangeRowsPerPage = (e) => {
    setSearchValue("");
    setPage(1);
    setPageSize(e.target.value);
  };

  const getCallHistoryDetails = (res) => {
    if (myCurrentTab == 1) {
      const newElements = [...elements, ...res.data];
      const uniqueElements = Array.from(
        new Set(newElements.map(JSON.stringify))
      ).map(JSON.parse);
      setElements(uniqueElements);
      setTotalNoRecord(res.total_count);
      if (res.total_count % pageSize === 0) {
        setTotalPage(parseInt(res.total_count / pageSize));
      } else {
        setTotalPage(parseInt(res.total_count / pageSize + 1));
      }

      if (res.total_count === 0) {
        setTimeout(() => {
          setSkeltonVal(true);
        }, "3000");
      } else {
        setSkeltonVal(true);
      }
    } else if (myCurrentTab == 2) {
      const newElements = [...inProgressElements, ...res.data];
      const uniqueElements = Array.from(
        new Set(newElements.map(JSON.stringify))
      ).map(JSON.parse);
      setInProgressElements(uniqueElements);
      setTotalNoRecord(res.total_count);
      if (res.total_count % pageSize === 0) {
        setTotalPage(parseInt(res.total_count / pageSize));
      } else {
        setTotalPage(parseInt(res.total_count / pageSize + 1));
      }

      if (res.total_count === 0) {
        setTimeout(() => {
          setSkeltonVal(true);
        }, "3000");
      } else {
        setSkeltonVal(true);
      }
    } else if (myCurrentTab == 3) {
      const newElements = [...completedElements, ...res.data];
      const uniqueElements = Array.from(
        new Set(newElements.map(JSON.stringify))
      ).map(JSON.parse);
      setCompletedElemets(uniqueElements);
      setTotalNoRecord(res.total_count);
      if (res.total_count % pageSize === 0) {
        setTotalPage(parseInt(res.total_count / pageSize));
      } else {
        setTotalPage(parseInt(res.total_count / pageSize + 1));
      }

      if (res.total_count === 0) {
        setTimeout(() => {
          setSkeltonVal(true);
        }, "3000");
      } else {
        setSkeltonVal(true);
      }
    } else if (myCurrentTab == 4) {
      const newElements = [...cancelledElements, ...res.data];
      const uniqueElements = Array.from(
        new Set(newElements.map(JSON.stringify))
      ).map(JSON.parse);
      setCancelledElements(uniqueElements);
      setTotalNoRecord(res.total_count);
      if (res.total_count % pageSize === 0) {
        setTotalPage(parseInt(res.total_count / pageSize));
      } else {
        setTotalPage(parseInt(res.total_count / pageSize + 1));
      }

      if (res.total_count === 0) {
        setTimeout(() => {
          setSkeltonVal(true);
        }, "3000");
      } else {
        setSkeltonVal(true);
      }
    } else if (myCurrentTab == 5) {
      const newElements = [...pendingElements, ...res.data];
      const uniqueElements = Array.from(
        new Set(newElements.map(JSON.stringify))
      ).map(JSON.parse);
      setPendingElements(uniqueElements);
      setTotalNoRecord(res.total_count);
      if (res.total_count % pageSize === 0) {
        setTotalPage(parseInt(res.total_count / pageSize));
      } else {
        setTotalPage(parseInt(res.total_count / pageSize + 1));
      }

      if (res.total_count === 0) {
        setTimeout(() => {
          setSkeltonVal(true);
        }, "3000");
      } else {
        setSkeltonVal(true);
      }
    } else if (myCurrentTab == 6) {
      const newElements = [...assignServiceElements, ...res.data];
      const uniqueElements = Array.from(
        new Set(newElements.map(JSON.stringify))
      ).map(JSON.parse);
      setAssignServiceElements(uniqueElements);
      setTotalNoRecord(res.total_count);
      if (res.total_count % pageSize === 0) {
        setTotalPage(parseInt(res.total_count / pageSize));
      } else {
        setTotalPage(parseInt(res.total_count / pageSize + 1));
      }

      if (res.total_count === 0) {
        setTimeout(() => {
          setSkeltonVal(true);
        }, "3000");
      } else {
        setSkeltonVal(true);
      }
    } else if (myCurrentTab == 7) {
      const newElements = [...paymentIssueElements, ...res.data];
      const uniqueElements = Array.from(
        new Set(newElements.map(JSON.stringify))
      ).map(JSON.parse);
      setPaymentIssueElements(uniqueElements);
      setTotalNoRecord(res.total_count);
      if (res.total_count % pageSize === 0) {
        setTotalPage(parseInt(res.total_count / pageSize));
      } else {
        setTotalPage(parseInt(res.total_count / pageSize + 1));
      }

      if (res.total_count === 0) {
        setTimeout(() => {
          setSkeltonVal(true);
        }, "3000");
      } else {
        setSkeltonVal(true);
      }
    }



    // console.log(parseInt(res.total_records / pageSize), 'quoitent')
  };

  function isCurrentUnixTimeLessThan(targetUnixTime) {

    const currentUnixTime = Math.floor(Date.now() / 1000);

    return currentUnixTime < targetUnixTime;
  }

  useEffect(() => {
    let details = {
      scheduled_tickets_flag: 2,
    };
    dispatch(
      getCounterApi(
        details,
        (res) => {
          setCounters(res.data);

          if (isCurrentUnixTimeLessThan(res?.data?.next_scheduled_job?.unix_datetime_stamp_end)) {
            // console.log("video token not expired");
            setIsActiveScheduledCall(1);
          } else {
            // console.log("video token expired");
            setIsActiveScheduledCall(0);
          }
        },
        () => { }
      )
    );
  }, []);
  const [isMore, setIsMore] = useState(true);
  const onLoadData = () => {
    setCustomeSkeletonLoading(true);
    let allTickets = new FormData();
    allTickets.append("page_index", page);
    allTickets.append("page_size", pageSize);
    allTickets.append("pagination_flag", 1);
    allTickets.append("sorting_order", sortByValue);
    allTickets.append("sorting_column_name", columnName);
    allTickets.append("search_area", searchValue);
    !permissionArray.includes("SCAN TAB") && allTickets.append("assigned_flag_ysn", 1);
    permissionArray.includes("SCAN TAB") && allTickets.append("scheduled_tickets_flag", 2);


    myCurrentTab !== 1 &&
      allTickets.append(
        "ticket_status_int",
        (myCurrentTab == 2 && 2) ||
        (myCurrentTab == 3 && 9) ||
        (myCurrentTab == 4 && 7) ||
        (myCurrentTab == 5 && 8) ||
        (myCurrentTab == 6 && 10) || 
        (myCurrentTab == 7 && 12)
      );

    setIsMore(false);
    dispatch(
      getTickets(allTickets, (res) => {
        if (res.data?.length !== 0) {
          setIsMore(true);
        }
        getCallHistoryDetails(res);
        setCustomeSkeletonLoading(false);
      }, () => { setCustomeSkeletonLoading(false); })
    );

    return;
  };

  const handleCheckDetails = (e) => {
    // console.log(e)

    // localStorage.setItem("ticket_id", e.ticket_id_ids)
    navigate("/particularTicketDetails");
  };

  const onChangePage = (e, p) => {
    // setPage(p)
    handleToggle(null);
    setPage(e);
  };

  const handleSearch = (e) => {
    // setPage(1)
    setPage(1);
    const ele = []
    setElements(ele);
    setCancelledElements(ele);
    setInProgressElements(ele);
    setCompletedElemets(ele);
    setPendingElements(ele);
    setAssignServiceElements(ele);
    setPaymentIssueElements(ele);
    handleToggle(null);
    if (searchValue.trim().length >= 2) {
      onChangePage(1);
      setColumnName("");
    }
    setSearchValue(e.target.value);
  };

  const handleCheckbox = (e, i) => {
    const array = [...bulkDeleteArr];
    if (array.includes(e.user_call_log_id_ids)) {
      var index = array.indexOf(e.user_call_log_id_ids);
      array.splice(index, 1);
      setBulkDeleteArr(array);
    } else {
      array.push(e.user_call_log_id_ids);
      setBulkDeleteArr(array);
    }
  };

  const handleBulkDelete = () => {
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      call_id_list: bulkDeleteArr,
      action_type: "M",
    };
    dispatch(
      bulkCallDelete(details, (res) => {
        setBulkDeleteArr([]);
        onLoadData();
      })
    );
  };

  const deleteSingleDetails = (e) => {
    setBulkDeleteArr([]);
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      user_call_log_id_ids: e.user_call_log_id_ids,
    };
    dispatch(
      deleteCallHistory(details, (res) => {
        onLoadData();
      })
    );
  };

  useEffect(() => {
    onLoadData();
  }, [
    pageSize,
    columnName,
    renderTicketListPro,
    myCurrentTab,
    filtreValue,
    page,
  ]);

  function onLoadDataSearch() {
    let allTickets = new FormData();
    allTickets.append("page_index", page);
    allTickets.append("page_size", pageSize);
    allTickets.append("pagination_flag", 1);
    allTickets.append("sorting_order", sortByValue);
    allTickets.append("sorting_column_name", columnName);
    allTickets.append("search_area", searchValue);
    !permissionArray.includes("SCAN TAB") && allTickets.append("assigned_flag_ysn", 1);
    permissionArray.includes("SCAN TAB") && allTickets.append("scheduled_tickets_flag", 2);


    myCurrentTab !== 1 &&
      allTickets.append(
        "ticket_status_int",
        (myCurrentTab == 2 && 2) ||
        (myCurrentTab == 3 && 9) ||
        (myCurrentTab == 4 && 7) ||
        (myCurrentTab == 5 && 8) ||
        (myCurrentTab == 6 && 10)
      );


    setIsMore(false);
    dispatch(
      getTickets(allTickets, (res) => {
        if (res.data?.length !== 0) {
          setIsMore(true);
        }
        getCallHistoryDetails(res);
        setCustomeSkeletonLoading(false);
      })
    );
  }

  useEffect(() => {
    if (searchValue.trim().length > 2) {

      const ele = [];
      setPage(1);
      setElements(ele);
      setCancelledElements(ele);
      setInProgressElements(ele);
      setCompletedElemets(ele);
      setPendingElements(ele);
      setAssignServiceElements(ele);
      setPaymentIssueElements(ele);
      setFlag(true);
      const timeOutId = setTimeout(onLoadDataSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
      if (flag) {
        onLoadDataSearch();
      }
    }
  }, [searchValue]);

  const percentage = 70;

  const tooltipJoinCall = (
    <Tooltip id="tooltip">
      <strong>Join call</strong>
    </Tooltip>
  );

  const tooltipCallEnded = (
    <Tooltip id="tooltip">
      <strong>This call has ended</strong>
    </Tooltip>
  );

  const tooltipDelete = (
    <Tooltip id="tooltip">
      <strong>Delete</strong>
    </Tooltip>
  );
  const tooltipView = (
    <Tooltip id="tooltip">
      <strong>View</strong>
    </Tooltip>
  );
  const tooltipCertified = (
    <Tooltip id="tooltip">
      <strong>Certified</strong>
    </Tooltip>
  );
  const tooltipNotCertified = (
    <Tooltip id="tooltip">
      <strong>Not Certified</strong>
    </Tooltip>
  );

  // With new logic
  const [expandedRow, setExpandedRow] = useState(null);

  const handleToggle = (rowIndex) => {
    if (rowIndex === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowIndex);
    }
  };

  const isRowExpanded = (rowIndex) => {
    return rowIndex === expandedRow;
  };

  // Modal triggers for the service requests details
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    onLoadData();
  };
  const handleShow = (e) => {
    localStorage.setItem("ticket_id", e?.ticket_id_ids);
    localStorage.setItem("ticket_display_name", e?.display_id_int);
    setTicketID(e.ticket_id_ids);
    setShow(true);
    navigate("/serviceRequestDetails");
    // navigate("/serviceRequestDetailsCopy");
  };

  // Modal triggers for the call details

  const handleCloseCallDetails = () => {
    setShowCallDetails(false);
    // ticketStatus(particularTicketID)
  };
  const handleShowCallDetails = (element) => {
    setCallLogIdIds(element.call_log_id_ids);
    setUserCallLogIdIds(element.user_call_log_id_ids);
    setShowCallDetails(true);
    navigate("/callDetails");
  };

  // Handling the call details listing from the services
  function ticketStatus(particularTicketID) {
    let ticketData = new FormData();

    ticketData.append("ticket_id_ids", particularTicketID);
    ticketData.append("page_index", 1);
    ticketData.append("page_size", 10);
    ticketData.append("sorting_order", "DESC");
    ticketData.append("sorting_column_name", "");
    ticketData.append("search_area", particularTicketID);
    ticketData.append("is_accepted_flag", 0);

    // const ticketData = {
    //     ticket_id_ids: ticketID,
    //     search_area: "",
    //     longitute_float: 0,
    //     latitude_float: 0,
    //     page_index: 1,
    //     page_size: 10,
    //     sorting_order: "DESC",
    //     sorting_column_name: "",
    // }

    dispatch(
      ticketCallRequest(
        ticketData,
        (res) => {
          setSentRequest(res.data.data);
          localStorage.setItem("ticket_id", res?.data.data[0].ticket_id_lng);
          localStorage.setItem(
            "ticket_display_name",
            res?.data.data[0].display_id_int
          );
          localStorage.setItem("roomCode", res?.data.data[0].room_id);
          localStorage.setItem(
            "user_call_log_id_ids",
            res?.data.data[0].user_call_log_id_ids
          );
          localStorage.setItem(
            "call_log_id",
            res?.data.data[0].call_log_id_ids
          );
        },
        () => { }
      )
    );
  }

  // Share Service Request functions start here ---------

  const handleCloseShareServiceModal = () => {
    setShowShareServiceModal(false);
    setEmailPhoneValue("");
    setCodeValue();
    setIsEmailPhoneVal(false);
  };

  const handleShareService = (e) => {
    e.preventDefault();
    if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
      setShareLoading(true);
      if (isPhone) {
        const data = new FormData();
        data.append("ticket_id_ids", ticketID);
        data.append("is_sharable_ysn", 1);
        data.append("email_chr", "");
        data.append("phone_code_id_int", parseInt(codeValue) || 1);
        data.append("phone_number_int", emailPhoneValue);

        dispatch(
          shareServiceRequest(
            data,
            (res) => {
              setShareLoading(false);
              setResponceMsg(res.data.message);
              setToasterType("success");

              handleCloseShareServiceModal();

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            },
            (err) => {
              setShareLoading(false);
              setResponceMsg(err.data.message);
              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      } else if (!isPhone) {
        const data = new FormData();
        data.append("ticket_id_ids", ticketID);
        data.append("is_sharable_ysn", 1);
        data.append("email_chr", emailPhoneValue);
        // data.append("phone_code_id_int", parseInt(codeValue) || 1);
        // data.append("phone_number_int", emailPhoneValue);

        dispatch(
          shareServiceRequest(
            data,
            (res) => {
              setShareLoading(false);
              setResponceMsg(res.data.message);
              setToasterType("success");

              handleCloseShareServiceModal();

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            },
            (err) => {
              setShareLoading(false);
              setResponceMsg(err.data.message);
              setToasterType("error");

              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    } else {
      setIsEmailPhoneVal(true);
    }
  };

  const handleEmailPhone = (e) => {
    setIsEmailPhoneVal(false);

    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
  };
  const handleDropdownValue = (e) => {
    setCodeValue(e.target.value);
  };

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  function handleEmailPhoneBlur() {
    if (isPhone) {
      if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    } else {
      if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
      }
    }
  }

  function handleOpenFiltreBox() {
    setFiltreBox(!filtreBox);
  }

  function handleSetFiltreValue(v) {
    SetFiltreValue(v);
    const ele = [];
    setPage(1);
    setElements(ele);
    setCancelledElements(ele);
    setInProgressElements(ele);
    setCompletedElemets(ele);
    setPendingElements(ele);
    setAssignServiceElements(ele);
    setPaymentIssueElements(ele);
    if (v === 1) {
      setSortByValue("DESC");
    } else if (v === 2) {
      setSortByValue("ASC");
    }
  }

  const scrollContainerRef = useRef(null);
  // Share Service Request functions ends here ---------
  const [isAtBottom, setIsAtBottom] = useState(false);
  const checkScroll = (event) => {
    const scrollDiv = scrollContainerRef.current;
    if (scrollDiv) {
      const isAtBottom =
        scrollDiv.scrollHeight - scrollDiv.scrollTop === scrollDiv.clientHeight;
      const isScrollingUp = scrollDiv.scrollTop < scrollDiv.lastScrollTop;

      // Trigger alert only when scrolling down and at the bottom
      if (isAtBottom) {
        setPage(page + 1);
      }

      // Store current scroll position for the next check
    }
  };

  function loadMoreFn(e) {
    localStorage.setItem("page", e);
  }

  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? "am" : "pm";
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  return (
    <div className="row d-flex justify-content-center align-items-center">
      <div className="col mx-3 align-items-center">
        {/* Pro section details */}
        {permissionArray.includes("CONNECT TAB") && (
          <div className="row mt-2">
            <div className="row w-100 mx-0 mb-3">
              <div className="col-lg-6 pe-lg-3 px-0 mt-2 ">
                <div className="h-100 mx-0 row">
                  <div className="col-12 px-0">
                    <div
                      className="w-100 h-100  shadow-lg"
                      style={{
                        backgroundColor: "rgba(251, 252, 255, 1)",
                        borderRadius: '16px'
                      }}
                    >
                      <div className="col-12 mb-2 p-2 h-100">
                        <div className="row mx-0 h-100">
                          <div className="align-items-center col-12 col-md-3 col-sm-4 d-flex  justify-content-center ">
                            <div
                              className="align-items-cente bg-white d-flex fs-2 justify-content-center text-black"
                              style={{ height: "60px", width: "90px" }}
                            >
                              <img src={openServiceImg} alt="logo" style={{ height: '60px', width: '90px' }} />
                              {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                            </div>
                          </div>

                          <div className="col-12 col-md-9 col-sm-8 d-flex align-items-center justify-content-start justify-md-content-center">
                            {counters?.open_services_count > 0 ?
                              // <span className="cursor-pointer"
                              //   onClick={() => {
                              //     navigate("/openServiceRequests");
                              //   }}
                              // >
                              //   {" "}
                              //   <span
                              //     style={{ fontWeight: "800", color: "black" }}>
                              //     {`${counters?.open_services_count || 0}`} open
                              //     jobs
                              //   </span>{" "}
                              //   <span>
                              //     {" "}
                              //     require your immediate expert assistance &nbsp;{" "}
                              //   </span>
                              //   <span
                              //     className="fs-5"
                              //     style={{ fontWeight: "800", color: "black" }}>
                              //     <FaArrowRight />
                              //   </span>
                              // </span> 
                              <>
                                <div className="d-flex align-items-center justify-content-center flex-column">
                                  <span className="fs-6 font-w500 text-black text-center">
                                    {`Help customers remotely in any of`}
                                  </span>
                                  <span
                                    className="fs-5 font-w700 text-center cursor-pointer text-hovered d-flex align-items-center"
                                    style={{ color: 'rgba(131, 154, 192, 1)' }}
                                    onClick={() => {
                                      navigate("/openServiceRequests");
                                    }}
                                  >
                                    {`${counters?.open_services_count || 0} open jobs`}
                                    <i className="bi bi-chevron-right ps-1"></i>
                                  </span>
                                </div>
                              </>

                              :
                              <>
                                <span className="fs-5 font-w500">
                                  {`No open jobs at the moment`}
                                </span>
                              </>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 ps-lg-3 px-0 mt-2">
                <div className="h-100 mx-0 row">
                  <div className="col-12 px-0">
                    <div className="w-100 h-100 shadow-lg"
                      style={{
                        backgroundColor: "rgba(251, 252, 255, 1)",
                        borderRadius: '16px'
                      }}
                    >
                      <div className="col-12 mb-2 p-2 h-100">
                        <div className="row mx-0 h-100">
                          <div className="align-items-center col-12 col-md-3 col-sm-4 d-flex justify-content-center ">
                            <div
                              className="align-items-cente bg-white d-flex fs-2 justify-content-center text-black"
                              style={{ height: "60px", width: "70px" }}
                            >
                              <img src={calendarImg} alt="logo" style={{ height: '60px', width: '70px' }} />
                              {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                            </div>
                          </div>

                          <div className="col-12 col-md-9 col-sm-8 d-flex  align-items-center ">

                            {isActiveSheduledCall == 1 ?


                              // <div className="fs-6">
                              //   You have{" "}
                              //   <span
                              //     className="cursor-pointer"
                              //     onClick={() => {
                              //       navigate("/scheduledServiceRequests");
                              //     }}
                              //     style={{
                              //       fontWeight: "800",
                              //       color: "black",
                              //       pointerEvents:
                              //         counters?.scheduled_service_requests_count >
                              //           0
                              //           ? "auto"
                              //           : "none",
                              //     }}>
                              //     {`${counters?.scheduled_service_requests_count ||
                              //       0
                              //       }`}{" "}
                              //     jobs scheduled
                              //   </span>{" "}
                              //   &nbsp;{" "}
                              //   <span
                              //     className="fs-5"
                              //     style={{ fontWeight: "800", color: "black" }}>
                              //     <FaArrowRight />
                              //   </span>
                              //   {counters?.next_scheduled_job?.unix_datetime_stamp_start &&
                              //     <>
                              //       <span>
                              //         <br></br>
                              //         <span
                              //           style={{ fontWeight: "800", color: "black" }}>
                              //           {" "}
                              //           Next scheduled job:
                              //         </span>{" "}
                              //         &nbsp;{formatUnixTimestamp(counters?.next_scheduled_job?.unix_datetime_stamp_start)}
                              //       </span>{" "}
                              //     </>
                              //   }
                              // </div>

                              <>
                                <div className="d-flex align-items-center justify-content-center flex-column">
                                  <span className="fs-6 font-w500 text-black text-center">
                                    {`Your next call scheduled for`}
                                  </span>
                                  {counters?.next_scheduled_job?.unix_datetime_stamp_start &&
                                    <span
                                      className="fs-5 font-w700 text-center cursor-pointer text-hovered d-flex align-items-center"
                                      style={{ color: 'rgba(131, 154, 192, 1)' }}
                                      onClick={() => {
                                        navigate("/scheduledServiceRequests");
                                        dispatch(setMyCurrentTabRedux(1))
                                      }}
                                    >
                                      {`${formatUnixTimestamp(counters?.next_scheduled_job?.unix_datetime_stamp_start)}`}
                                      <i className="bi bi-chevron-right ps-1"></i>
                                    </span>
                                  }
                                </div>
                              </>
                              :
                              <>
                                <span className="fs-5 font-w500">
                                  {`No calls scheduled at the moment`}
                                </span>
                              </>
                            }

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Select Section */}

        {/* 
        
        myCurrentTab === 1 -- All Jobs
        myCurrentTab === 2 -- Job in progress
        myCurrentTab === 3 -- Completed
        myCurrentTab === 4 -- Cancelled
        
        */}
        <div
          className="row shadow-lg px-2 my-1"
          style={{
            backgroundColor: "rgba(251, 252, 255, 1)",
            borderRadius: '16px',
          }}
        >

          <div
            className="row mx-0 my-3 align-items-center "
            style={{ minHeight: "40px" }}>
            <div className="col-12 col-xl-7 d-flex py-3 overflow-auto">

              <span
                className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                style={{
                  border: "1px solid rgba(131, 154, 192, 1)",
                  fontWeight: "700",
                  height: "40px",
                  backgroundColor: myCurrentTab === 1 ? "rgba(79, 93, 116, 1)" : "white",
                  color: myCurrentTab === 1 ? "white" : "",
                }}
                onClick={() => {
                  dispatch(setMyCurrentTabRedux(1));
                }}
              >
                {permissionArray.includes("CONNECT TO PRO")
                  ? `All requests`
                  : `All jobs`}

                {counters?.all_service_requests_count > 0 && <span
                  className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                  style={{
                    top: '-9px',
                    right: '2px',
                    background: 'rgba(131, 154, 192, 1)',
                  }}
                >
                  {`${counters?.all_service_requests_count || 0}`}
                </span>}
              </span>

              <span
                className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                style={{
                  border: "1px solid rgba(131, 154, 192, 1)",
                  fontWeight: "700",
                  height: "40px",
                  backgroundColor: myCurrentTab === 5 ? "rgba(79, 93, 116, 1)" : "white",
                  color: myCurrentTab === 5 ? "white" : "",
                }}
                onClick={() => {
                  dispatch(setMyCurrentTabRedux(5));
                }}>
                {`Pending`}

                {counters?.pending_service_requests_count > 0 && <span
                  className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                  style={{
                    top: '-9px',
                    right: '2px',
                    background: 'rgba(131, 154, 192, 1)',
                  }}
                >
                  {`${counters?.pending_service_requests_count || 0}`}
                </span>}
              </span>

              <span
                className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                style={{
                  border: "1px solid rgba(131, 154, 192, 1)",
                  fontWeight: "700",
                  height: "40px",
                  backgroundColor: myCurrentTab === 2 ? "rgba(79, 93, 116, 1)" : "white",
                  color: myCurrentTab === 2 ? "white" : "",
                }}
                onClick={() => {
                  dispatch(setMyCurrentTabRedux(2));
                }}>
                {`Active`}

                {counters?.in_progress_services_count > 0 && <span
                  className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                  style={{
                    top: '-9px',
                    right: '2px',
                    background: 'rgba(131, 154, 192, 1)',
                  }}
                >
                  {`${counters?.in_progress_services_count || 0}`}
                </span>}
              </span>



              <span
                className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                style={{
                  border: "1px solid rgba(131, 154, 192, 1)",
                  fontWeight: "700",
                  height: "40px",
                  backgroundColor: myCurrentTab === 3 ? "rgba(79, 93, 116, 1)" : "white",
                  color: myCurrentTab === 3 ? "white" : "",
                }}
                onClick={() => {
                  dispatch(setMyCurrentTabRedux(3));
                }}>
                {`Closed`}

                {counters?.closed_services_count > 0 && <span
                  className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                  style={{
                    top: '-9px',
                    right: '2px',
                    background: 'rgba(131, 154, 192, 1)',
                  }}
                >
                  {`${counters?.closed_services_count || 0}`}
                </span>}
              </span>

              <span
                className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                style={{
                  border: "1px solid rgba(131, 154, 192, 1)",
                  fontWeight: "700",
                  height: "40px",
                  backgroundColor: myCurrentTab === 4 ? "rgba(79, 93, 116, 1)" : "white",
                  color: myCurrentTab === 4 ? "white" : "",
                }}
                onClick={() => {
                  dispatch(setMyCurrentTabRedux(4));
                }}>
                {`Cancelled`}

                {counters?.cancelled_service_requests_count > 0 && <span
                  className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                  style={{
                    top: '-9px',
                    right: '2px',
                    background: 'rgba(131, 154, 192, 1)',
                  }}
                >
                  {`${counters?.cancelled_service_requests_count || 0}`}
                </span>}
              </span>

              {(permissionArray.includes("UPDATE WORK INFORMATION") || permissionArray.includes("ASSIGN SERVICE REQUEST")) &&
                <span
                  className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                  style={{
                    border: "1px solid rgba(131, 154, 192, 1)",
                    fontWeight: "700",
                    height: "40px",
                    backgroundColor: myCurrentTab === 6 ? "rgba(79, 93, 116, 1)" : "white",
                    color: myCurrentTab === 6 ? "white" : "",
                  }}
                  onClick={() => {
                    dispatch(setMyCurrentTabRedux(6));
                  }}>
                  {`Assign services`}

                  {counters?.assigned_service_requests_count > 0 && <span
                    className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                    style={{
                      top: '-9px',
                      right: '2px',
                      background: 'rgba(131, 154, 192, 1)',
                    }}
                  >
                    {`${counters?.assigned_service_requests_count || 0}`}
                  </span>}
                </span>}

              {/* {(permissionArray.includes("CONNECT TO PRO")) &&
                <span
                  className=" d-flex align-items-center fs-7 px-3 pointer rounded-2 position-relative me-2 text-hovered border-hovered"
                  style={{
                    border: "1px solid rgba(131, 154, 192, 1)",
                    fontWeight: "700",
                    height: "40px",
                    backgroundColor: myCurrentTab === 7 ? "rgba(79, 93, 116, 1)" : "white",
                    color: myCurrentTab === 7 ? "white" : "",
                  }}
                  onClick={() => {
                    dispatch(setMyCurrentTabRedux(7));
                  }}>
                  {`Payment issues`}

                  {counters?.payment_issue_service_requests_count > 0 && <span
                    className="px-2 py-1 fs-7 text-white position-absolute rounded-pill d-flex align-items-center justify-content-center font-w500"
                    style={{
                      top: '-9px',
                      right: '2px',
                      background: 'rgba(131, 154, 192, 1)',
                    }}
                  >
                    {`${counters?.payment_issue_service_requests_count || 0}`}
                  </span>}
                </span>} */}


            </div>

            <div className="col-12 col-xl-5">
              <div className="row">
                <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                  <span className="fs-5 p-2 d-flex align-items-center">
                    <LuArrowUpDown
                      className="pointer"
                      style={{ marginRight: "4px", color: "black" }}
                      onClick={handleOpenFiltreBox}
                    />
                    <span
                      className="fs-6  pointer"
                      style={{ position: "relative" }}
                      onClick={handleOpenFiltreBox}>
                      {filtreValue == 1 && "Date: Newest first"}
                      {filtreValue == 2 && "Date: Oldest first"}
                      {/* {filtreValue == 3 && " Price: Highest first"}
                      {filtreValue == 4 && "Price: Lowest first"}{" "} */}
                      &nbsp;
                      {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                      <span
                        className={`${filtreBox ? "" : "d-none"} p-3`}
                        style={{
                          position: "absolute",
                          top: "26px",
                          width: "170px",
                          zIndex: 1,
                          border: "1px solid lightgray",
                          background: "white",
                          right: "0",
                          boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                        }}>
                        <div className="row">
                          <div
                            className={`${filtreValue == 1 ? "dt" : ""
                              } d-flex justify-content-start m-1 pointer `}
                            onClick={() => {
                              handleSetFiltreValue(1);
                            }}>
                            <div className="d-flex align-items-center" style={{ width: '20px' }}>
                              {filtreValue == 1 && <i className="bi bi-check-lg"></i>}
                            </div>
                            Date: Newest first
                          </div>
                          <div
                            className={`${filtreValue == 2 ? "dt" : ""
                              } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(2);
                            }}>
                            <div className="d-flex align-items-center" style={{ width: '20px' }}>
                              {filtreValue == 2 && <i className="bi bi-check-lg"></i>}
                            </div>
                            Date: Oldest first
                          </div>
                          {/* <div
                            className={`${
                              filtreValue == 3 ? "dt" : ""
                            } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(3);
                            }}>
                            Price: Highest first
                          </div>
                          <div
                            className={`${
                              filtreValue == 4 ? "dt" : ""
                            } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(4);
                            }}>
                            Price: Lowest first
                          </div> */}
                        </div>
                      </span>
                    </span>
                  </span>

                  <span
                    className="fs-6 p-2 d-flex align-items-center"
                    style={{
                      border: "1px solid lightgray",
                      borderRadius: "6px",
                    }}>
                    <FaSearch style={{ marginRight: "4px", color: "black" }} />
                    <input
                      placeholder="Search"
                      style={{ border: "0px", width: "100%" }}
                      onChange={handleSearch}
                      value={searchValue}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Table Section */}
        <div className="mb-2">
          {/* {(
            (myCurrentTab == 1 && elements) ||
            (myCurrentTab == 2 && inProgressElements) ||
            (myCurrentTab == 3 && completedElements) ||
            (myCurrentTab == 4 && cancelledElements)
          ).map((data, id) => (
            <>
              <div
                className="row mx-0 mt-3 pb-2"
                style={{ borderBottom: "1px solid rgba(241, 241, 241, 1)" }}>
                <div className="col-12">
                  <div
                    onClick={() => handleShow(data)}
                    className="row mx-0 overlay-action-btn cursor-pointer">
                    <div
                      className="col-3 col-md-1 d-flex justify-content-center align-items-center "
                      style={{ background: "#F1F1F1" }}>
                      {data.image_url ? (
                        <img src={data.image_url} className="w-100" alt="" />
                      ) : (
                        <i
                          style={{ fontSize: "20px" }}
                          className="bi bi-images"></i>
                      )}
                    </div>
                    <div className="col-9 col-md-11 px-3 pb-1">
                      <div className="row  ">
                        <div className="col-6">
                          <span
                            className=" pt-2"
                            style={{
                              color: "gray !important",
                              fontSize: "9px",
                            }}>
                            {new Date(
                              data?.created_date_dtm * 1000
                            ).toLocaleString("en-US", {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            })}
                          </span>
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                          {data.category_display_name_chr !== ("" || null) && (
                            <span
                              className="fs-7 px-3 py-1"
                              style={{
                                background: "#F1F1F1",
                                borderRadius: "39px",
                              }}>
                              {`${data.category_display_name_chr} ${data.product_type_chr &&
                                ` / ${data.product_type_chr}`
                                }`}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 mb-3">
                          <span
                            className="fs-6 text-black "
                            style={{ fontWeight: "800", color: "black" }}>
                            {data.problem_description_chr === ("" || null)
                              ? "Problem description not specified"
                              : data.problem_description_chr}
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                          <span className="fs-7 ">#{data.display_id_int}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))} */}



          {/* CustomTable component */}
          <CustomTable
            elements={
              (myCurrentTab == 1 && elements) ||
              (myCurrentTab == 2 && inProgressElements) ||
              (myCurrentTab == 3 && completedElements) ||
              (myCurrentTab == 4 && cancelledElements) ||
              (myCurrentTab == 5 && pendingElements) ||
              (myCurrentTab == 6 && assignServiceElements) ||
              (myCurrentTab == 7 && paymentIssueElements)
            }
            tableType={1}
            onRowClick={handleShow}
          />



          {/* <InfiniteScroll
    pageStart={0}
    loadMore={(e)=>{loadMoreFn(e)}}
    hasMore={isMore }
   
    loader={<div className="loader" key={0}>Loading ...</div>}
></InfiniteScroll> */}

          {customeSkeletonLoading &&
            <>
              {[...Array(5)].map((data, id) =>
                <SkeletonForServices key={id} />
              )}
            </>
          }

          {customeSkeletonLoading
            ? (
              (myCurrentTab == 1 && elements) ||
              (myCurrentTab == 2 && inProgressElements) ||
              (myCurrentTab == 3 && completedElements) ||
              (myCurrentTab == 4 && cancelledElements) ||
              (myCurrentTab == 5 && pendingElements) ||
              (myCurrentTab == 6 && assignServiceElements) ||
              (myCurrentTab == 7 && paymentIssueElements)
            )?.length > 0 &&
            totalNoRecord >
            (
              (myCurrentTab == 1 && elements) ||
              (myCurrentTab == 2 && inProgressElements) ||
              (myCurrentTab == 3 && completedElements) ||
              (myCurrentTab == 4 && cancelledElements) ||
              (myCurrentTab == 5 && pendingElements) ||
              (myCurrentTab == 6 && assignServiceElements) || 
              (myCurrentTab == 7 && paymentIssueElements)
            )?.length && (
              <div className="text-center pointer my-2">Loading ...</div>
            )
            : (
              (myCurrentTab == 1 && elements) ||
              (myCurrentTab == 2 && inProgressElements) ||
              (myCurrentTab == 3 && completedElements) ||
              (myCurrentTab == 4 && cancelledElements) ||
              (myCurrentTab == 5 && pendingElements) ||
              (myCurrentTab == 6 && assignServiceElements) ||
              (myCurrentTab == 7 && paymentIssueElements)
            )?.length > 0 &&
            totalNoRecord >
            (
              (myCurrentTab == 1 && elements) ||
              (myCurrentTab == 2 && inProgressElements) ||
              (myCurrentTab == 3 && completedElements) ||
              (myCurrentTab == 4 && cancelledElements) ||
              (myCurrentTab == 5 && pendingElements) ||
              (myCurrentTab == 6 && assignServiceElements) ||
              (myCurrentTab == 7 && paymentIssueElements)
            )?.length && (
              <div
                className="text-center pointer my-3"
                onClick={() => {
                  setPage(page + 1);
                }}>
                click to view more
              </div>
            )}

          {!customeSkeletonLoading && totalNoRecord == 0 && (
            <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

              <div className="mb-2">
                <img src={searchImg} alt="search" style={{ width: "70px" }} />
              </div>
              <span>
                {`No record found`}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceRequests;
